export const SAVE_TOKEN = "saveToken";
export const DELETE_TOKEN = "deleteToken";
export const SET_USER_ERROR = "setUserError";
export const EXTERNAL_ERROR = "externalError";
